
import React from 'react';
import { Button } from "@/components/ui/button";
import { Check, Circle } from 'lucide-react';
import { cn } from '@/lib/utils';

interface WizardNavProps {
  currentStep: number;
  totalSteps: number;
  stepLabels: string[];
  onStepClick: (step: number) => void;
  isStepCompleted: (step: number) => boolean;
}

export const WizardNav = ({ 
  currentStep, 
  totalSteps, 
  stepLabels, 
  onStepClick, 
  isStepCompleted 
}: WizardNavProps) => {
  return (
    <div className="space-y-1 sticky top-20">
      {stepLabels.map((label, index) => (
        <Button
          key={label}
          variant="ghost"
          className={cn(
            "w-full justify-start h-auto py-3 px-4",
            currentStep === index ? "bg-muted" : "hover:bg-muted/50",
          )}
          onClick={() => onStepClick(index)}
        >
          <div className="flex items-center gap-3">
            <div className={cn(
              "flex h-6 w-6 shrink-0 items-center justify-center rounded-full border",
              currentStep === index ? "border-primary bg-primary text-primary-foreground" : 
              isStepCompleted(index) ? "border-primary bg-primary text-primary-foreground" : 
              "border-muted-foreground text-muted-foreground"
            )}>
              {isStepCompleted(index) ? (
                <Check className="h-3 w-3" />
              ) : (
                <span className="text-xs">{index + 1}</span>
              )}
            </div>
            <span className={cn(
              "text-sm font-medium",
              currentStep === index ? "text-foreground" : "text-muted-foreground"
            )}>
              {label}
            </span>
          </div>
        </Button>
      ))}
    </div>
  );
};
